const portfolioListData = [
	{
		title: 'Technium.com',
		url: false,
		position: 'VCTO | Full Stack Developer',
		description: `
			<p>
				I have developed for Technium an application that allows people around a world publish their challenges and bring technologies to the table to solve them.
			</p>
			<p>
				Techium uses <abbr title="Meteor.js">Meteor.js</abbr> (Node.js) with Blaze as a view layer and MongoDB as a database. On the front-end, it uses Postcss with a portion of plugins helps to optimize and speed up the coding.
			</p>
			<p>
				It has posting, voting, discussion, invitation and account systems. It also include search by API with filters.
			</p>
			<p>
				This job also included a lot of UI / UX work
			</p>
		`,
		pictureSrc: '/img/previews/technium.png',
		techs: [
			'Meteor.js',
			'Node.js',
			'MongoDB',
			'DDP',
			'Blaze',
			'Responsive Design',
			'HTML',
			'CSS',
			'Stylus',
			'JavaScript',
			'jQuery',
			'UI',
			'UX'
		]
	},
	{
		title: 'Inshape',
		url: 'https://wellwhere.pokrovskii.com/',
		position: 'Full Stack Developer',
		description: `
			<p>Inshape is an effective search application of sports gyms similar to Airbnb.</p>
			<p>The user can find a suitable gym based on a region, an address, activities or reviews. The application provides a map to find a suitable location wich work similar to Airbnb. After choosing the gym a customer can buy a pass right on the application. Which can be validated by gym's administrator right from the interface. </p>
			<p>It has been built from the scratch. And include a lot of features like:
				<abbr title="custom search">custom search</abbr>,
				<abbr title="user profile">user profile</abbr>,
				<abbr title="e-commerce">e-commerce</abbr>,
				<abbr title="reviews">reviews</abbr>,
				<abbr title="favorites">favorites</abbr>,
				<abbr title="airbnb-like map">airbnb-like map</abbr>.
			</p>
		`,
		pictureSrc: '/img/previews/wellwhere.png',
		techs: [
			'PHP',
			'Wordpress',
			'MySQL',
			'REST',
			'Stripe',
			'Gulp.js',
			'Google Maps API',
			'CSS',
			'PostCSS',
			'SCSS',
			'Responsive Design',
			'JavaScript',
			'jQuery',
			'HTML',
			'UI',
			'UX'
		]
	},
	{
		title: 'Healthcare enterprise cloud solution for Gregory Limited',
		url: undefined,
		position: 'Full Stack Developer',
		description: `
			<p>I provided front end & back end development.</p>
			<p>My responsibility was developing the API bridge between 3rd-party supply storage and the main application.</p>
		`,
		pictureSrc: undefined,
		techs: [
			'Meteor.js',
			'Node.js',
			'Odoo CRM',
			'API',
			'MongoDB',
			'DDP',
			'Blaze',
			'JavaScript'
		]
	},
	{
		title: 'Slack clone for a Healthcare app based on the rocket.chat',
		url: 'https://teamstitch.com/',
		position: 'Full Stack Developer',
		description: `
			<p>
				"Stitch" offers healthcare teams a HIPAA-compliant, team communication experience across all devices.
			</p>
			<p>I was responsible for front end &amp; back end development.</p>
		`,
		pictureSrc: undefined,
		techs: [
			'Meteor.js',
			'Rocket.chat',
			'Node.js',
			'MongoDB',
			'DDP',
			'Blaze',
			'JavaScript',
		]
	},
	{
		title: 'Rei.Com - Blogs',
		url: 'https://www.rei.com/blog',
		position: 'Full Stack Developer',
		description: `
			<p>
				REI operates 154 retail stores in 36 states. REI sells sporting goods, camping gear, travel equipment, and clothing. It also offers services such as outdoor-oriented vacations and courses. REI operates 154 retail stores in 36 states.
			</p>
			<p>
				For a months I've been providing <abbr title="front end &amp; back end development">front end &amp; back end development</abbr> for their blogs creating varius of features including:
					<abbr title="custom templates">custom templates</abbr> for different purposes,
					<abbr title="youtube API integration">youtube API</abbr> integration,
					<abbr title="custom user profiles">custom user profiles</abbr>,
					<abbr title="custom comments functionality">custom comments functionality</abbr>,
					and many others.
			</p>
			<p>Also, I've been working on improvement a speed performance</p>
		`,
		pictureSrc: '/img/previews/rei.png',
		techs: [
			"PHP",
			"Wordpress",
			"MySQL",
			"REST",
			"Gulp.js",
			"CSS",
			"PostCSS",
			"SCSS",
			"Responsive Design",
			"JavaScript",
			"jQuery",
			"HTML",
			"UI",
			"UX",
		]
	},
	{
		title: 'LPK.COM',
		url: 'https://www.lpk.com/',
		position: 'Front End Developer',
		description: `
			<p>LPK is the global largest employee-owned brand design agency in the world.</p>
			<p>I have created a dozen landing pages. And established environment and workflow for a fast and stable landing page developing.</p>
		`,
		pictureSrc: '/img/previews/lpk.png',
		techs: [
			"JavaScript",
			"Gulp.js",
			"PostCSS",
			"Responsive Design",
			"SCSS",
			"HTML",
			"CSS",
		]
	},
	{
		title: 'Popsop.Com',
		url: 'http://popsop.com',
		position: 'VCTO | Full Stack Developer',
		description: `
			<p>Popsop.com is a news website owned and operated by the Moscow-based brand and design agency BQB, part of LINII Group.</p>
			<p>
				I have created this site from the ground up and provided support for years.
			</p>
			<p>
				During this long time, popsop.com experienced several complete redesigns and complete code refactoring.
			</p>
			<p>
				It also has been developed around performance and stability. Currently, popsop.com support 200,000+ readers each month
			</p>
		`,
		pictureSrc: '/img/previews/popsop.png',
		techs: [
			"PHP",
			"Wordpress",
			"MySQL",
			"REST",
			"Gulp.js",
			"CSS",
			"PostCSS",
			"SCSS",
			"JavaScript",
			"jQuery",
			"HTML",
			"UI",
			"UX",
		]
	},

];

export default portfolioListData;


// WEBPACK FOOTER //
// ./src/portfolioListData.js